// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"631":"CookiePreferences","743":"AccessibilityStatement"}[chunkId] + "." + {"631":"3f849b88","743":"3f849b88"}[chunkId] + ".chunk.css";
};